import React, { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { resolveLocalizedText } from '../helpers/resolveLocalizedText';
import { CAROUSEL_SCROLL_POSITION_KEY_DESKTOP } from '../common/constants';
import { Page } from '../components/__design-system/layout/page';
import { SubtitleText } from '../components/__design-system/typography/subtitle';
import { TitleText } from '../components/__design-system/typography/title';
import { BookWithAlternativePlatform, BookWithTablz } from '../components/booking-options';
import { LanguageSelector } from '../components/language-selector/LanguageSelector';
import { useSessionStorage } from '../hooks/useSessionStorage';
import { RestaurantGuardOutletContext } from '../routes/RestaurantGuard';
import styles from './LandingPage.module.scss';

export const LandingPageBookingOptions = () => {
	const { i18n } = useTranslation();
	const { restaurant, featureFlags } = useOutletContext<RestaurantGuardOutletContext>();

	const [, , resetCarouselPosition] = useSessionStorage(CAROUSEL_SCROLL_POSITION_KEY_DESKTOP, '');

	useEffect(() => {
		// Reset saved scroll position if entering from landing page
		resetCarouselPosition();
	}, []);

	/* Flip the landing tiles if feature flag is ON and there is no error fetching the flag */
	const shouldFlipTiles = Boolean(featureFlags?.flipLandingModal);

	const firstOption = shouldFlipTiles ? (
		<BookWithAlternativePlatform />
	) : (
		<BookWithTablz />
	);
	const secondOption = shouldFlipTiles ? (
		<BookWithTablz />
	) : (
		<BookWithAlternativePlatform />
	);

	const headerTitle = restaurant.settings?.branding?.header?.title?.trim();
	const displayTitle = headerTitle
		? headerTitle
		: restaurant.displayName;

	return (
		<Page as='main'>
			<LanguageSelector />
			<div className='flex flex-col px-4 py-2'>
				<TitleText>{resolveLocalizedText(displayTitle, i18n.language)}</TitleText>
				<SubtitleText>{resolveLocalizedText(restaurant.displayAddress, i18n.language)}</SubtitleText>
			</div>

			<div className={styles.Options}>
				{firstOption}
				{secondOption}
			</div>
		</Page>
	);
};
